var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.21,4.68a4.2,4.2,0,0,1,0,8.4,5,5,0,0,1-2.69-1c-1.21.05-2.18,1.56-2.18,1.56a6.82,6.82,0,1,0,4.87-11.6h0A6.54,6.54,0,0,0,6.4,8.53a4.32,4.32,0,0,1,2.86-1.1,4.21,4.21,0,0,1,4-2.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.79,10.92a6.29,6.29,0,0,1,2.61.92c1,0,2.28-1.47,2.28-1.47A6.78,6.78,0,0,0,10.79,8.3h0a6.82,6.82,0,1,0,6.81,7.23,4.55,4.55,0,0,1-2.9,1.13,4.2,4.2,0,1,1-3.91-5.74"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.fbc62a9a0f3ea63bff80a129da389b43.svg";
export { ForwardRef as ReactComponent };